export const SCROLL_AREA_STYLES = {
  root: "relative overflow-hidden",
  viewport: "h-full w-full rounded-[inherit]",
  scrollbar: {
    base: "flex touch-none select-none transition-colors",
    vertical: "h-full w-2.5 border-l border-l-transparent p-[1px]",
    horizontal: "h-2.5 flex-col border-t border-t-transparent p-[1px]",
  },
  thumb: "relative flex-1 rounded-full bg-border",
} as const;
